import React from 'react';

const Card = ({ title, children, className = '' }) => {
  return (
    <div className={`bg-white border border-borderLight shadow-shadowElevated rounded-radiusMd overflow-hidden ${className}`}>
      {title && (
        <div className="px-4 py-5 sm:px-6 border-b border-headerBorder">
          <h3 className="text-lg leading-6 font-medium text-textPrimary">{title}</h3>
        </div>
      )}
      <div className="px-4 py-5 sm:p-6">{children}</div>
    </div>
  );
};

export default Card; 